import React, { useContext, useEffect, useRef } from "react";

// ✅ Context ------------------------------------------------------------------------------------------------------------
import { GlobalContext } from "../context/Store";

// ✅ Components ------------------------------------------------------------------------------------------------------------
import { useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import SectionTitle from "../components/SectionTitle";

// ✅ Icon ------------------------------------------------------------------------------------------------------------
// import { RiArrowDropRightLine } from "react-icons/ri";

// ✅ Data ------------------------------------------------------------------------------------------------------------
import myInformation from "../data/myInformation";

const Education = ({ paddingTopToDiffer = "pt-10", heightToDiffer = "h-auto" }) => {
  // ✅ States / Variables ------------------------------------------------------------------------------------------------------------
  const { setNavLinkActiveName, textAnimationCustom, animateDelay } = useContext(GlobalContext);
  const { pathname } = useLocation();
  const scrollToTop = useRef();
  const { imgAnimationCustom } = useContext(GlobalContext);
  // ✅ useEffect ------------------------------------------------------------------------------------------------------------
  useEffect(() => {
    if (pathname === "/Education") scrollToTop.current.scrollIntoView({ behavior: "smooth" });

    setNavLinkActiveName("Education");
    document.title = `${myInformation.educationSection.iAmWhat} | Education`;
  }, []);

  return (
    <div
      ref={scrollToTop}
      className={`box-border flex h-auto w-full flex-col bg-white px-8 pb-20 sm:px-12 md:flex-col lg:px-16 ${paddingTopToDiffer} ${heightToDiffer}`}
    >
      <div className="flex w-full flex-col items-center gap-4">
        <SectionTitle title={"My,Education"} />

      </div>
      <div className="mt-12 flex flex-col">

        {/* 1 */}
        <motion.div
          className="box-border w-full ml-18 md:w-1/1 md:pl-18 md:pt-8 rounded-lg shadow-lg border border-black"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2, duration: 0.5 }}
        >
          <div className="flex items-center ml-2">
            <img className="w-0/2 rounded-lg mb-7 " src="./images/Education/uws.jpg" alt="University of West Scotland" />
            <motion.p {...textAnimationCustom(0.2)} className="font-open-sans-font text-1.5xl font-bold mb-9  ml-12">
              {myInformation.educationSection.WhatStudy}
            </motion.p>
          </div>
        </motion.div>


        {/* 2 */}
        <motion.div
          className="box-border w-full ml-18 md:w-1/1 md:pl-18 md:pt-8 mt-9 rounded-lg shadow-lg border border-black"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2, duration: 0.5 }}
        >            <div className="flex items-start">
            <img className="w-0/5 mr-5 ml-2 mb-5 rounded-lg" src="./images/Education/Abtimg.jpg" alt="Comsats Institute of Information Technology" />
            <motion.p
              {...textAnimationCustom(0.27)}
              className="mt-2 w-full font-open-sans-font font-medium leading-7 tracking-normal md:mt-4 md:w-[85%] md:tracking-wide"
            >
              {myInformation.educationSection.myeducationDetails}
            </motion.p>
          </div>
        </motion.div>

        {/* 3 */}
        <motion.div
          className="box-border w-full ml-18 md:w-1/1 md:pl-18 md:pt-8 mt-8 rounded-lg shadow-lg border border-black"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2, duration: 0.5 }}
        >           <div className="flex items-center ml-2">
            <img className="w-0/2 rounded-lg mb-7 " src="./images/Education/ComsataUNI.jpg" alt="University of West Scotland" />
            <motion.p {...textAnimationCustom(0.2)} className="font-open-sans-font text-1.5xl mb-11 font-bold ml-12">
              {myInformation.educationSection.myStudyinfo}
            </motion.p>
          </div>
        </motion.div>
      </div>
    </div>
  );


};

export default Education;
